import React, { useState, useEffect } from 'react';
import './PhoneInput.css';

const PhoneInput = ({ onSubmit }) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isValid, setIsValid] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const cleanPhoneNumber = (input) => {
    // Remove all non-digit characters (spaces, dots, etc)
    return input.replace(/[^0-9]/g, '');
  };

  const handleInputChange = (e) => {
    const input = e.target.value;
    
    // Clean the input to keep only digits
    const cleaned = cleanPhoneNumber(input);
    
    // Take only first 10 digits if input is longer
    const truncated = cleaned.slice(0, 10);
    
    // Update the phone number state
    setPhoneNumber(truncated);
    
    // Validate the phone number
    if (truncated.length === 10) {
      if (truncated[0] === '0') {
        setIsValid(true);
        setErrorMessage('');
      } else {
        setIsValid(false);
        setErrorMessage('Số điện thoại phải bắt đầu bằng số 0');
      }
    } else {
      setIsValid(false);
      setErrorMessage(truncated.length > 0 ? 'Số điện thoại phải có 10 chữ số' : '');
    }
  };

  const handlePaste = (e) => {
    // Prevent default paste behavior
    e.preventDefault();
    
    // Get pasted content
    const pastedText = e.clipboardData.getData('text');
    
    // Clean and process the pasted text
    const cleaned = cleanPhoneNumber(pastedText);
    const truncated = cleaned.slice(0, 10);
    
    // Update input value
    setPhoneNumber(truncated);
    
    // Validate the pasted number
    if (truncated.length === 10) {
      if (truncated[0] === '0') {
        setIsValid(true);
        setErrorMessage('');
      } else {
        setIsValid(false);
        setErrorMessage('Số điện thoại phải bắt đầu bằng số 0');
      }
    } else {
      setIsValid(false);
      setErrorMessage(truncated.length > 0 ? 'Số điện thoại phải có 10 chữ số' : '');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && isValid) {
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    if (isValid) {
      onSubmit(phoneNumber);
    }
  };

  return (
    <div className="phone-input-container">
      <div className="input-group">
        <div className="input-label">
          <span className="section-title">
            Nhập số cần xem
          </span>
          <span className="input-hint" style={{ color: 'red' }}>
            Số điện thoại có 10 chữ số
          </span>
        </div>
      </div>

      <div className={`input-wrapper ${isFocused ? 'focused' : ''} ${isValid ? 'valid' : ''} ${errorMessage ? 'error' : ''}`}>
        <input
          type="tel"
          placeholder="0XXXXXXXXX"
          value={phoneNumber}
          onChange={handleInputChange}
          onPaste={handlePaste}
          onKeyDown={handleKeyDown}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          inputMode="numeric"
          aria-label="Nhập số điện thoại của bạn"
          autoComplete="tel"
        />
        {isValid && (
          <div className="valid-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="#2ecc71" strokeWidth="2"/>
              <path d="M7 13l3 3 7-7" stroke="#2ecc71" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        )}
        {errorMessage && <div className="error-message">{errorMessage}</div>}
      </div>

      <button 
        onClick={handleSubmit}
        disabled={!isValid}
        className={`submit-button ${isValid ? 'active' : ''}`}
      >
        <span className="button-text">Tra cứu miễn phí</span>
        <span className="button-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </span>
      </button>
    </div>
  );
};

export default PhoneInput;
